import {
  AnalyticsContext,
} from '@gcc/adobe-analytics';
import { buildBaseEventData } from './commonAnalytics';
import { sites } from '../helpers/globalVariables';

const createStashProperty = (items) => {
  const stash = {
    pageType: 'tool:diy estimates:estimates',
    sharedSection: '',
    section: '',
    component: '',
    target: 'atc',
    item: items.map(() => ({
      index: '',
      product: '',
    })),
  };

  return stash;
};

const createItemProperty = (items) => {
  const item = items.map(i => ({
    productInfo: {
      sku: i.itemProduct.skuNumber,
    },
    quantity: i.quantity,
    price: {
      basePrice: i.retail,
    },
    fulfillment: {
      method: 'sth',
    },
  }));

  return item;
};

const estimateItemToAutobahnAnalyticsEvent = (items) => {
  const eventData = buildBaseEventData('button submission', 'cart add');

  eventData.item = items.map((item) => {
    const { retail, itemProduct } = item;
    const colorAttribute = itemProduct.attributes.find(attribute => attribute.name === 'Color');

    return {
      productInfo: {
        sku: itemProduct.skuNumber,
        option: {
          color: colorAttribute ? colorAttribute.value : '',
          price: itemProduct.optionTotal,
        },
        productName: itemProduct.productName,
        productCategory: itemProduct.productCategory,
        manufacturer: itemProduct.vendor,
        productType: 'product',
      },
      quantity: 1,
      price: { basePrice: retail },
    };
  });

  return [eventData];
};

export const toAddToCartAnalyticsEvent = (items) => {
  if (window.globalConfig.siteId === sites.theHomeDepot) {
    const analyticsContext = new AnalyticsContext(window.globalConfig.siteId);

    const stash = createStashProperty(items);
    const addToCartLocationEvent = analyticsContext.createAddToCartLocationEvent(stash);

    const item = createItemProperty(items);
    const addToCartEvent = analyticsContext.createAddToCartEvent(item);

    return [addToCartLocationEvent, addToCartEvent];
  }

  return estimateItemToAutobahnAnalyticsEvent(items);
};

export const sendAddToCartEvent = (items) => {
  const analyticsContext = new AnalyticsContext(window.globalConfig.siteId);
  const addToCartEvent = toAddToCartAnalyticsEvent(items);
  const isSafari = (navigator.userAgent.indexOf('Safari') !== -1
                    && navigator.userAgent.indexOf('Chrome') === -1);

  addToCartEvent.forEach((event) => {
    if (isSafari) {
      // eslint-disable-next-line no-underscore-dangle
      window._T && window._T.sendEventDataToAnalytics(event);
    } else {
      try {
        analyticsContext.sendAnalyticsEvent(event);
      } catch (error) {
        // eslint-disable-next-line
        console.log('analyticsContext.sendAnalyticsEvent: ', error);
      }
    }
  });
};

